import type { SelectFieldOption } from '@hrlogics/react-helper-types';

import { VerificationRequestStatus, VerificationRequestType } from 'src/api';
import { VERIFICATION_REQUEST_TYPE_LABEL } from 'src/constants/verificationRequest';

export const STATUS_TO_NOTE_MAPPING = {
  [VerificationRequestStatus.EmployeeToRespond]: {
    header: 'Please note',
    text: "This verification request is pending your employee's decision to either approve or deny it. Once the individual submits their response, you will see an update to this inbox item reflecting their decision.",
  },
  [VerificationRequestStatus.DeclinedByEmployee]: {
    header: 'Declined by Employee',
    text: 'Your employee has denied this verification request, and as a result, no verification report has been generated. No further action is needed on your part.',
  },
  [VerificationRequestStatus.VerifierToRespond]: {
    header: 'Verifier to Respond',
    text: 'This verification request was initiated by your employee and is currently awaiting a response from the designated verifier to either approve or deny the request. Once the verifier submits their decision, you will see an update in this inbox item. No action is required on your part at this time.',
  },
  [VerificationRequestStatus.DeclinedByVerifier]: {
    header: 'Declined by Verifier',
    text: 'This verification request, initiated by your employee, has been denied by the verifier, resulting in no verification report being generated. No further action is needed on your part.',
  },
  [VerificationRequestStatus.ReportCreated]: { header: 'Report Created', text: '' },
  [VerificationRequestStatus.ReviewedByVerifier]: { header: 'Reviewed by Verifier', text: '' },
} as const satisfies Record<VerificationRequestStatus, { header: string; text: string }>;

export const COMMERCIAL_VERIFICATION_TYPES_OPTIONS = [
  {
    label: VERIFICATION_REQUEST_TYPE_LABEL[VerificationRequestType.VerificationOfEmployment],
    value: VerificationRequestType.VerificationOfEmployment,
  },
  {
    label: VERIFICATION_REQUEST_TYPE_LABEL[VerificationRequestType.VerificationOfIncome],
    value: VerificationRequestType.VerificationOfIncome,
  },
] as const satisfies SelectFieldOption[];

export const GOVERNMENT_VERIFICATION_TYPES_OPTIONS = [
  {
    label: VERIFICATION_REQUEST_TYPE_LABEL[VerificationRequestType.GovernmentalVerification],
    value: VerificationRequestType.GovernmentalVerification,
  },
] as const satisfies SelectFieldOption[];
